// extracted by mini-css-extract-plugin
export default {"price":"HCemI","old":"s2Lsh","period":"kCLVV","zero":"CtI8z","icon":"eNQzm"};